//console.log('load frontend-functions.js')
export function bottomReached (){
    //console.log('bottomReached function ===========');
    if (typeof itemsPerPage === 'undefined') {
        var itemsPerPage = 20;
    }
    if (typeof ajaxIsFinished === 'undefined') {
        var ajaxIsFinished = true;
    }
	var currPage = Math.round($(".bottom-news-wrapper-ajax").children().length / itemsPerPage);
    //console.log('currPage =================', currPage);
	if (ajaxIsFinished && currPage > 0) {
		ajaxIsFinished = false;
		var divToAppend = $(".bottom-news-wrapper-ajax");
		var ajax_url = "/ajax/bottom_news";
		var data_params = {page: currPage, subcat_url_name: subcatUrlName, maincat_url_name: maincatUrlName, tag_id: tagId, team_id: teamId};
		if (!divToAppend.hasClass("loading-ajx")) {
		$.ajax({url: ajax_url, data: data_params, dataType: "text", type: "POST", beforeSend: function () {
			divToAppend.addClass("loading-ajx");
            $('.page-loader').addClass('shown');
		}, success: function (m) {
			if (divToAppend) {
			divToAppend.append(m);
			this.containerNode = $(divToAppend)
			}
		}, complete: function () {
			divToAppend.removeClass("loading-ajx");		
            $('.page-loader.shown').removeClass('shown');
		}});
		}
		setTimeout(processingAjax, 2500);
		return false;
	}
	function processingAjax() {
		ajaxIsFinished = true;
	}
}


export function toggleDropDown() {
    
}

//expand/collapse usually detaild element
export function toggleExpandable(idExpandable) {
    console.log('toggled function called', idExpandable );

    $('#' + idExpandable).toggleClass('collapsed expanded');
    $('[data-id="'+ idExpandable +'"]').toggleClass('collapsed expanded');
    
}

//tabs
export function tabClicked(tabWrapperId, hideversion, identifier) {
    //tabs - active/inactive
    //console.log('hub tabClicked function!!!!   tabWrapperId, hideversion, identifier ', tabWrapperId, hideversion, identifier);
    $('#' + tabWrapperId + ' .tab.active').removeClass('active');
    $('#' + tabWrapperId + ' .tab#' + identifier).addClass('active');
    
    //content - hidden/unhidden
    $('#' + tabWrapperId + ' .tab-content[data-id="' + identifier + '"]').removeClass(hideversion);
    $('#' + tabWrapperId + ' .tab-content:not([data-id="' + identifier + '"])').addClass(hideversion);
}